import Monsters from "./Monsters";

export default Monsters;
